import React from 'react'
import PropTypes from 'prop-types'

import * as Styled from './OpeningHours.styles'

import { useTextContext } from 'hocs'

const OpeningHours = ({
  openingHours,
  showTimeNotice,
  showAppointmentOnly,
  className,
}) => {
  const textContext = useTextContext()

  return (
    <Styled.Container
      className={ className }
      data-testid={ 'opening-hours-container' }
      data-cy-opening-hours={ Object.keys(openingHours).join(',') }>
      <Styled.TimeRowWrapper>
        {Object.keys(openingHours).map((day, key) => (
          <Styled.TimeRow key={ key }>
            <Styled.TimeRowTitle data-testid={ 'time-row-title' }>
              {day}
            </Styled.TimeRowTitle>
            <Styled.TimeRowList>
              {Object.keys(openingHours[day]).map((time, key) => (
                <Styled.TimeRowListItem
                  key={ key }
                  time={ openingHours[day][time] }
                  data-testid={ `time-row-list-item-${ key }` }>
                  {openingHours[day][time]}
                </Styled.TimeRowListItem>
              ))}
            </Styled.TimeRowList>
          </Styled.TimeRow>
        ))}
      </Styled.TimeRowWrapper>
      {showAppointmentOnly && (
        <Styled.TimeRowListAppointment>
          {textContext['opening.hours.appointmentOnly']}
        </Styled.TimeRowListAppointment>
      )}
      {showTimeNotice && (
        <Styled.TimeRowListHint data-testid={ 'time-row-list-hint' }>
          {textContext['opening.hours.info']}
        </Styled.TimeRowListHint>
      )}
    </Styled.Container>
  )
}

OpeningHours.defaultProps = {
  showTimeNotice: true,
  showAppointmentOnly: false,
}

OpeningHours.propTypes = {
  /* data which contains opening times for doctors */
  openingHours: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
    .isRequired,
  /** flag for show notice that times could vary on illness or vacation **/
  showTimeNotice: PropTypes.bool,
  showAppointmentOnly: PropTypes.bool,
  className: PropTypes.string,
}

export default OpeningHours
